import { domain } from "commons/config";

export function monetize(price: number) {
    const formatter = Intl.NumberFormat("en-US", { style: "decimal" });

    let value = formatter.format(price);

    value = value.replace(new RegExp(",", "g"), " ");
    value = value + " €";

    return value;
}

export function translateType(type: string, lang: string) {
    if ((!type) || (!lang)) return type;

    const langTexts: Record<string, Record<string, string>> = {
        nl: {
            Apartment: "Apartement",
            House: "Huis",
            Villa: "Villa",
            Studio: "Studio",
            Bungalow: "Bungalow"
        },
        fr: {
            Apartment: "Appartement",
            House: "Maison",
            Villa: "Villa",
            Studio: "Studio",
            Bungalow: "Bungalow"
        },
    };

    if (Object.keys(langTexts).indexOf(lang) < 0) return type;

    return langTexts[lang][type];
}

export function submitContactForm(form: HTMLFormElement, setMessage: Function, extra: Record<string, any> = {}) {
    const formData = new FormData(form);
    const data = { ...Object.fromEntries(formData.entries()), ...extra };

    let messages: Record<string, any> = {};

    messages.success = {
        title: "Thank you",
        text: "Your message has been sent successfully.",
        buttons: [{ name: "Ok", action: () => { setMessage(null) } }]
    };
    messages.error = {
        title: "Sorry",
        text: "Your message could not be sent. Try again.",
        buttons: [{ name: "Ok", action: () => { setMessage(null) } }]
    };

    fetch(domain + "/sendMessage", { method: "POST", body: JSON.stringify(data) }).then(response => {
        if (response.ok) {
            form.reset();
            setMessage(messages.success);
        } else {
            setMessage(messages.error);
        }
    }).catch(() => { setMessage(messages.error) });
}